import React, { useEffect, useState } from 'react'
import ModalContainer from '../../common/modal/ModalContainer'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { getUserInfo, printApiError } from '../../helpers/Util'
import surveySparrowApi from '../../lib/surveySparrow/surveySparrowApi'
import { toast } from 'react-toastify'
import {
    NPS_SCORES,
    PROD_QUOTE_SURVEY_ID,
    TEST_QUOTE_SURVEY_ID
} from '../../lib/surveySparrow/helper'
import { closeLoader, openLoader } from '../../redux_toolkit/Loader'
import { useDispatch } from 'react-redux'
import { QouteActions } from '../../redux_toolkit/Quote/QuoteSlice'
import { SET_IS_HIGHLIGHT_FEEDBACK } from '../../redux_toolkit/@types/action.types'
import { isItProductionServer } from '../../constant'

const QuoteFeedbackModal = ({ onCloseModal }) => {
    const [npsScore, setNpsScore] = useState(null)
    const [feedback, setFeedback] = useState('')
    const [isFeedbackSubmitted, setIsFeedbackSubmitted] = useState(false)
    const [responseId, setResponseId] = useState(null)
    const [questionList, setQuestionList] = useState([])
    const [contactList, setContactList] = useState([])
    const dispatch = useDispatch()

    const getQuestionList = async () => {
        try {
            const response = await surveySparrowApi.get(
                `/questions?survey_id=${
                    isItProductionServer()
                        ? PROD_QUOTE_SURVEY_ID
                        : TEST_QUOTE_SURVEY_ID
                }`
            )
            setQuestionList(response.data)
        } catch (error) {
            printApiError(error)
        }
    }

    const getContactList = async () => {
        dispatch(openLoader())
        try {
            const response = await surveySparrowApi.get(
                `/contacts?search=${getUserInfo().email}`
            )
            setContactList(response.data)
            dispatch(closeLoader())
        } catch (error) {
            printApiError(error)
            dispatch(closeLoader())
        }
    }

    useEffect(() => {
        if (isFeedbackSubmitted) {
            dispatch(QouteActions[SET_IS_HIGHLIGHT_FEEDBACK](true))
        }
    }, [isFeedbackSubmitted])

    useEffect(() => {
        getQuestionList()
        getContactList()
    }, [])

    const submitAnswer = async (answer, questionId) => {
        try {
            dispatch(openLoader())
            const requestBody = {
                survey_id: isItProductionServer()
                    ? PROD_QUOTE_SURVEY_ID
                    : TEST_QUOTE_SURVEY_ID,
                contact_id: contactList[0]?.id,
                answers: [
                    {
                        answer,
                        question_id: questionId
                    }
                ]
            }

            const response = responseId
                ? await surveySparrowApi.put(
                      `/responses/${responseId}`,
                      requestBody
                  )
                : await surveySparrowApi.post('/responses', requestBody)
            dispatch(closeLoader())
            return response
        } catch (error) {
            toast.error('Something went wrong')
            dispatch(closeLoader())
        }
    }

    const handleNpsClick = async (score) => {
        const response = await submitAnswer(score, questionList[0]?.id)
        if (response?.data?.id) {
            setNpsScore(score)
            setResponseId(response?.data?.id)
            if (score > 7) {
                setIsFeedbackSubmitted(true)
            }
        }
    }

    const handleSubmit = async () => {
        const response = await submitAnswer(feedback, questionList[1]?.id)
        if (response?.data?.id) {
            setIsFeedbackSubmitted(true)
            setTimeout(onCloseModal, 20000)
        }
    }

    const renderNpsRating = () => (
        <div className='nps-rating-container'>
            <h4 className='semibold-16 mb-3'>{questionList[0]?.rtxt}</h4>
            <div className='nps-rating-items'>
                {NPS_SCORES.map((score) => (
                    <div
                        key={score}
                        className={`nps-rating-item cursor-pointer ${
                            npsScore === score ? 'active' : ''
                        }`}
                        onClick={() => handleNpsClick(score)}
                    >
                        {score}
                    </div>
                ))}
            </div>
            <div className='nps-rating-hint d-flex justify-content-between mt-1'>
                <p className='regular-12 gray_300'>Least Likely</p>
                <p className='regular-12 gray_300'>Most Likely</p>
            </div>
        </div>
    )

    const renderFeedbackForm = () => (
        <div className='nps-feedback-container'>
            <label className='semibold-16 mb-3'>{questionList[1]?.rtxt}</label>
            <textarea
                placeholder='Write in details'
                className='h-20'
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                autoFocus
            />
        </div>
    )

    const renderSuccessMessage = () => (
        <div className='feedback-submitted text-center py-10 mb-4'>
            <p className='semibold-18 mb-2'>
                Thanks for your valuable feedback!
            </p>
            <p className='regular-14 gray_400'>
                We will use your feedback to improve our service.
            </p>
        </div>
    )

    return (
        <ModalContainer
            className='price-range-modal'
            onCloseModal={onCloseModal}
        >
            <div className='common-popup'>
                <div className='common-popup-header d-flex justify-content-between'>
                    <div className='popup-tilte'>
                        <h3 className='semibold-16 mb-0'>
                            {!isFeedbackSubmitted &&
                                'Please rate your experience'}
                        </h3>
                    </div>
                    <div
                        className='close-btn cursor-pointer'
                        onClick={onCloseModal}
                    >
                        <CloseIcon />
                    </div>
                </div>

                <div className='common-popup-body'>
                    <div className='question'>
                        {(npsScore === null || npsScore > 7) &&
                            !isFeedbackSubmitted &&
                            renderNpsRating()}

                        {npsScore <= 7 &&
                            npsScore !== null &&
                            !isFeedbackSubmitted &&
                            renderFeedbackForm()}

                        {isFeedbackSubmitted && renderSuccessMessage()}
                    </div>
                </div>
                <div className='common-popup-footer text-end'>
                    {npsScore <= 7 &&
                        npsScore !== null &&
                        !isFeedbackSubmitted && (
                            <button
                                className='button primary mr-3'
                                onClick={handleSubmit}
                                disabled={!feedback.trim()}
                            >
                                <span>Submit</span>
                            </button>
                        )}
                </div>
            </div>
        </ModalContainer>
    )
}

export default QuoteFeedbackModal
